import { PropsWithChildren } from 'react';
import { Box } from '@bridebook/ui';
import componentStyles from './above-request-button.style';

const AboveRequestButton = ({ children }: PropsWithChildren) => {
  const styles = componentStyles();

  return (
    <Box style={styles.wrapper} data-name="above-request-button">
      {children}
    </Box>
  );
};

export default AboveRequestButton;
